import { service } from 'services';
import { hotGetAction, basicCRUDAction, getMyEmail } from 'utils';
import { ACTIONS_TYPES } from '../helper';

const userActions = {
  getAll: async () => hotGetAction({
    action: ACTIONS_TYPES.USER.GET_ALL,
    apiResult: service.user.getAll(),
    payloadKey: 'users',
    isRetrieveItems: true,
  }),

  get: async ({ userId }) => hotGetAction({
    action: ACTIONS_TYPES.USER.GET,
    apiResult: service.user.get({ id: userId }),
    payloadKey: 'user',
  }),

  create: async ({ user }) => basicCRUDAction({
    action: ACTIONS_TYPES.USER.CREATE,
    apiResult: service.user.create({ user }),
  }),

  update: async ({ id, user }) => basicCRUDAction({
    action: ACTIONS_TYPES.USER.UPDATE,
    apiResult: service.user.update({ id, user }),
  }),

  delete: async ({ id }) => basicCRUDAction({
    action: ACTIONS_TYPES.USER.DELETE,
    apiResult: service.user.delete({ id }),
  }),

  getAllResources: async () => hotGetAction({
    action: ACTIONS_TYPES.COMMON.GET_ALL_RESOURCES,
    apiResult: service.user.getAllResources(),
    payloadKey: 'resources',
    isRetrieveItems: true,
  }),

  getCurrentUser: async () => hotGetAction({
    action: ACTIONS_TYPES.USER.GET_CURRENT_USER,
    apiResult: service.user.getAll(),
    retrieveByFunction: (e) => {
      const { items: users = [] } = e;
      const email = getMyEmail();
      return users.find(({ properties }) => properties.email === email);
    },
  }),

  getGroupsForUser: async ({ userId }) => hotGetAction({
    action: ACTIONS_TYPES.GROUP.GET_USER_GROUPS,
    apiResult: service.user.getGroupsForUser({ userId }),
    isRetrieveItems: true,
  }),
};

export default userActions;
